import { HOUR_IN_MINUTES } from './dates';
import { Levels } from 'enums';

import type { RemoteLevel } from 'types';

const firstLevelInfo = [
  'You are remote-first in all aspects of the company.',
  'You have very few, if any, must-attend meetings, and these are usually monthly.',
  'You are a truly global, remote-first company with no bounds on location.',
  'You are very experienced at remote life and remote hiring, a leader and inspiration for others.',
  'Assuming waking hours fall between 8AM - 8PM',
];

const secondLevelInfo = [
  'You are proudly remote-first when it comes to communication and workflows.',
  'Your recurring meetings are weekly or bi-weekly rather than daily, and tools like meeting recordings, loom, and notes, make meeting attendance mostly optional.',
  'You are experts and leaders at asynchronous work and have already hired many global employees, but still continue to explore new geographies.',
  'Assuming work hours fall between 9AM - 6PM',
];

const thirdLevelInfo = [
  'You have meetings and collaborate synchronously every day, but do your best to reduce redundancies and make adjustments for remote team mates.',
  'You prioritize the remote work experience and environment.',
  'You already have multiple international team mates and are excited to grow this number.',
  'Assuming work hours fall between 9AM - 6PM',
];

const fourthLevelInfo = [
  'You may or may not have an office, but the majority of your staff are still in a centralized area.',
  'You would say your company culture and schedule are flexible to employee needs.',
  'You often have meetings every day on video and/or in person with multiple members of the team or company.',
  'You check in several times a day with your team.',
  'Assuming work hours fall between 9AM - 6PM',
];

const fifthLevelInfo = [
  'You have a physical office and central location where the majority of your current employees/team reside, even if they are working from home.',
  'You work at very specific times and synchronous collaboration is a must at almost all times.',
  'Every employee must be active and responsible at all times during your work hours.',
  'Assuming work hours fall between 9AM - 6PM',
];

// todo probably this should be rewritten to a function that returns an array
export const levels: RemoteLevel[] = [
  {
    level: Levels.One,
    name: 'Fully asynchronous',
    overlapLabel: '1+ Hours Overlap',
    workingDayStartAmPm: { hours: 8, ampm: 'am' },
    workingDayEndAmPm: { hours: 8, ampm: 'pm' },
    allowedOverlap: HOUR_IN_MINUTES,
    isCustom: false,
    info: firstLevelInfo,
  },
  {
    level: Levels.Two,
    name: 'Mostly asynchronous',
    overlapLabel: '1+ Hours Overlap',
    workingDayStartAmPm: { hours: 9, ampm: 'am' },
    workingDayEndAmPm: { hours: 6, ampm: 'pm' },
    allowedOverlap: HOUR_IN_MINUTES * 2,
    isCustom: false,
    info: secondLevelInfo,
  },
  {
    level: Levels.Three,
    name: 'Less than 3 hours of meeting a day',
    overlapLabel: '3+ Work Hours Overlap',
    workingDayStartAmPm: { hours: 9, ampm: 'am' },
    workingDayEndAmPm: { hours: 6, ampm: 'pm' },
    allowedOverlap: HOUR_IN_MINUTES * 3,
    isCustom: false,
    info: thirdLevelInfo,
  },
  {
    level: Levels.Four,
    name: 'More than 3 hours of meeting a day',
    overlapLabel: '5+ Work Hours Overlap',
    workingDayStartAmPm: { hours: 9, ampm: 'am' },
    workingDayEndAmPm: { hours: 6, ampm: 'pm' },
    allowedOverlap: HOUR_IN_MINUTES * 5,
    isCustom: false,
    info: fourthLevelInfo,
  },
  {
    level: Levels.Five,
    name: 'All hours overlap a day',
    overlapLabel: '7+ Work Hours Overlap',
    workingDayStartAmPm: { hours: 9, ampm: 'am' },
    workingDayEndAmPm: { hours: 6, ampm: 'pm' },
    allowedOverlap: HOUR_IN_MINUTES * 7,
    isCustom: false,
    info: fifthLevelInfo,
  },
  {
    level: Levels.Six,
    name: 'Custom hours',
    overlapLabel: 'Set your own start and end of the day',
    workingDayStartAmPm: { hours: 8, ampm: 'am' },
    workingDayEndAmPm: { hours: 8, ampm: 'pm' },
    // this has to be in minutes as well, fix this later
    allowedOverlap: HOUR_IN_MINUTES * 2,
    isCustom: true,
    info: [],
  },
];
